import React, { Component } from "react";
import connect from "react-redux/es/connect/connect";
import { Button, Card, CardBody, CardTitle, Col, Label, Row } from "reactstrap";
import axios from "axios";
import Alerts from "../../util/Alerts";
import BlkFormik from "../../util/BlkFormik";
import { Form } from "formik";
import { find_aseguradoras, find_companias, find_ram_grupos, find_ramos, find_ramos_ramgrp } from "../../api/CacheApi";
import { BlkCalendario } from "../../coms/BlkCalendario";
import ReactTable from "react-table";
import { on_select } from "../polizas/actions";
import { BlkField } from "../../coms/BlkField";
import { routes } from "../General";
import { has_role, pos } from "../../util/General";
import { DetallesGEN } from "./DetallesGEN";
import moment from "moment";
import "moment/locale/es";
import { ComboCliente } from "../ComboCliente";
import { BlkCheckBox } from "../../coms/BlkCheckBox";

class SiniestrosGEN extends Component {
    constructor(props) {
        super(...arguments);
        this.alert = React.createRef();
        this.form = React.createRef();
        this.state = {
            data: [],
            ramos: [],
            asegs: [],
            companias: [],
            vehiculo: [],
            pages: -1,
            page: 0,
            loading: false,
            item: {},
            cot: {},
            modalSiniestroVidas: false,
            busquedaAvanzada: false,
            modalDocs: false,
            tipo: "siniestros",
            query: this.itemQuery(),
        };
    }

    itemQuery() {
        return {
            page: 0,
            pageSize: 10,
            poliza: "",
            cdRamo: 0,
            cdReclamo: "",
            cdAseguradora: 0,
            numSiniestro: "",
            anio: "",
            dscObjeto: null,
            cdCompania: 1,
            cdCliente: this.props.user.cdCliente,
            cdEjecutivoAdm: this.props.user.cdEjecutivoAdm || 0,
            ci: this.props.user.cedula,
            fcDesde: new Date(new Date().getFullYear() - 1, new Date().getMonth(), 1),
            fcHasta: new Date(),
            sorted: null,
            inclEjecutivo: false,
            cdPool: this.props.user.cdPool,
        };
    }

    componentDidMount() {
        find_ramos().then(resp => {
            let ramos = resp;
            find_ram_grupos().then(resp => {
                let areas = resp;
                find_ramos_ramgrp().then(resp => {
                    let ramosTmp = [];
                    resp.forEach(r => {
                        let item = Object.assign({}, r); //clono el item
                        item.nmRamo = ramos.find(ramo => ramo.cdRamo === item.cdRamo).nmRamo;
                        item.nmArea = areas.find(area => area.cdRamGrupo === item.cdRamGrupo).nmRamGrupo;
                        item.nm = item.nmRamo;
                        if (!this.isVam(item)) {
                            ramosTmp.push(item);
                        }
                    });
                    this.setState({ ramos: ramosTmp.sort((a, b) => a.nmRamo.localeCompare(b.nmRamo)) });
                });
            });
        });

        find_aseguradoras().then(resp => {
            this.setState({ asegs: resp });
        });

        find_companias().then(resp => {
            this.setState({ companias: resp });
        });
    }

    /**
     * funcion a ejecutarse cuando se da click en guardar desde el menu
     */
    onSubmit = (newValues, { setSubmitting }) => {
        this.setState(
            {
                query: { ...this.state.query, ...newValues, page: 0 },
                page: 0,
            },
            () => this.fetchData({}, null, setSubmitting)
        );
    };

    fetchData = (query = {}, _table, setSubmitting) => {
        if (has_role(this.props.user, "ROLE_ADMIN") || this.state.query.cdCliente) {
            let query2 = Object.assign({}, this.state.query);
            query2.sorted = query.sorted;
            if (query.page >= 0) {
                query2.page = query.page;
                // query2.page = 1;
            }

            if (query.pageSize >= 0) {
                query2.pageSize = query.pageSize;
            }

            if (query2.page !== this.state.query.page || query2.page === 0) {
                axios
                    .post(routes.api + "/siniestros-gen/search", query2)
                    .then(resp => {
                        this.setState({
                            data: resp.data.content,
                            pages: resp.data.totalPages,
                            loading: false,
                            sorted: resp.data.sorted,
                        });
                        setSubmitting && setSubmitting(false);
                    })
                    .catch(error => {
                        setSubmitting && setSubmitting(false);
                        this.alert.current.handle_error(error);
                    });
            }
        }
    };

    onSelectCoti = coti => {
        this.setState({ item: coti });
        this.showSiniestroVidas(true);
        this.props.on_select({ cot: coti, query: this.state.query });
    };

    verDocDigital = coti => {
        this.setState({ item: coti }, () => {
            this.showDocs(true);
            this.showSiniestroVidas(false);
        });
    };

    showSiniestroVidas = open => {
        this.setState({ modalSiniestroVidas: open });
    };

    showDocs = open => {
        this.setState({ modalDocs: open });
    };

    isVam = r => {
        let vam = false;
        let ls_nm_grp_ramo = r.nmArea;

        if (pos(ls_nm_grp_ramo, "MEDICA") > 0) {
            //pb_actvam.TriggerEvent(Clicked!)
            vam = true;
        } else if (pos(ls_nm_grp_ramo, "VIDA") > 0) {
            //pb_actvam.TriggerEvent(Clicked!)
            vam = true;
        } else {
            vam = false;
        }
        return vam;
    };
    closeModalDoc = () => {
        this.setState({ modalDocs: false });
    };
    handleResetForm = resetForm => {
        this.setState({ ...this.state, query: this.itemQuery(), data: [], data1: [], selected: -1 });
        resetForm();
    };
    showBusquedaAvanzada = open => {
        this.setState({ busquedaAvanzada: open });
    };

    render() {
        return (
            <div className="content ">
                <Alerts ref={this.alert} />
                <Card>
                    <CardBody>
                        <CardTitle tag="h4">Siniestro Generales</CardTitle>
                        <div className="container-fluid container-md">
                            <BlkFormik
                                initialValues={this.state.query}
                                onSubmit={this.onSubmit}
                                ref={this.form}
                                enableReinitialize={true}
                                validateOnChange={false}
                            >
                                {({
                                    values,
                                    isSubmitting,
                                    errors,
                                    handleChange,
                                    resetForm,
                                    submitForm,
                                    setFieldValue,
                                }) => (
                                    <Form>
                                        <Row>
                                            {(has_role(this.props.user, "ROLE_ADMIN") ||
                                                has_role(this.props.user, "ROLE_BROKER")) && (
                                                <div className="form-group col-lg-6">
                                                    <ComboCliente
                                                        setFieldValue={setFieldValue}
                                                        name={"cdCliente"}
                                                        alert={this.alert}
                                                        values={values}
                                                    />
                                                </div>
                                            )}
                                            {has_role(this.props.user, "ROLE_EJECUTIVO") && (
                                                <Col xs={2} className={"d-flex  align-items-center"}>
                                                    <Label className={"mr-2"}>Ejecutivo</Label>
                                                    <BlkField
                                                        component={BlkCheckBox}
                                                        styleInput={{ marginLeft: 0, marginTop: "-10px" }}
                                                        name={"inclEjecutivo"}
                                                    />
                                                </Col>
                                            )}
                                            {(has_role(this.props.user, "ROLE_ADMIN") ||
                                                has_role(this.props.user, "ROLE_BROKER")) &&
                                                !this.state.busquedaAvanzada && (
                                                    <div className="form-group col-lg-6">
                                                        <div className="m-1">
                                                            <Button
                                                                type={"submit"}
                                                                color="primary"
                                                                className="my-xl-4"
                                                                onClick={() => {
                                                                    document
                                                                        .getElementById("siniestroGen")
                                                                        .scrollIntoView({ behavior: "smooth" });
                                                                    submitForm();
                                                                }}
                                                            >
                                                                Buscar
                                                            </Button>
                                                        </div>
                                                    </div>
                                                )}
                                        </Row>
                                        <Row>
                                            <div className="form-group col-lg-6">
                                                <Button
                                                    color="primary"
                                                    className="btn my-md-4"
                                                    onClick={() => {
                                                        this.showBusquedaAvanzada(!this.state.busquedaAvanzada);
                                                    }}
                                                >
                                                    Búsqueda Avanzada
                                                </Button>
                                            </div>
                                        </Row>
                                        <br />
                                        {this.state.busquedaAvanzada && (
                                            <>
                                                <Row>
                                                    <div className="form-group col-lg-6">
                                                        <Label>Póliza: </Label>
                                                        <BlkField
                                                            className="form-control"
                                                            type="text"
                                                            placeholder="Póliza"
                                                            name="poliza"
                                                        />
                                                    </div>
                                                    <div className="form-group col-lg-6">
                                                        <Label>Aseguradora: </Label>
                                                        <BlkField
                                                            component="select"
                                                            className="form-control w-100 inputTable"
                                                            name="cdAseguradora"
                                                        >
                                                            <option value="0">--TODOS--</option>
                                                            {this.state.asegs.map(aseg => (
                                                                <option
                                                                    key={aseg.cdAseguradora}
                                                                    value={aseg.cdAseguradora}
                                                                >
                                                                    {aseg.nmAlias}
                                                                </option>
                                                            ))}
                                                        </BlkField>
                                                    </div>

                                                    <div className="form-group col-lg-6">
                                                        <Label>Ramo: </Label>
                                                        <BlkField
                                                            component="select"
                                                            className="form-control w-100 inputTable"
                                                            name="cdRamo"
                                                        >
                                                            <option value="0">--TODOS--</option>
                                                            {this.state.ramos.map(ramo => (
                                                                <option key={ramo.cdRamo} value={ramo.cdRamo}>
                                                                    {ramo.nmRamo}
                                                                </option>
                                                            ))}
                                                        </BlkField>
                                                    </div>
                                                    <Col xs={12} sm={6}>
                                                        <Row>
                                                            <div className="form-group col-lg-6">
                                                                <Label>No. Siniestro: </Label>
                                                                <BlkField
                                                                    name="numSiniestro"
                                                                    className="form-control"
                                                                    type="text"
                                                                    placeholder="No. Siniestro"
                                                                />
                                                            </div>
                                                            <div className="form-group col-lg-6">
                                                                <Label>Año Siniestro: </Label>
                                                                <BlkField
                                                                    className="form-control"
                                                                    type="text"
                                                                    placeholder="Año Siniestro"
                                                                    name="anio"
                                                                />
                                                            </div>
                                                        </Row>
                                                    </Col>
                                                </Row>

                                                <div className="row">
                                                    <div className="form-group col-lg-6 m-0">
                                                        <small className="m-0 text-primary">
                                                            Fecha de Ocurriencia del Siniestro
                                                        </small>
                                                    </div>
                                                </div>
                                                <Row>
                                                    <Col xs={12} sm={6}>
                                                        <Row>
                                                            <div className="form-group col-lg-6">
                                                                <Label>Desde: </Label>
                                                                <BlkField
                                                                    name="fcDesde"
                                                                    placeholder="Ingrese Fecha"
                                                                    component={BlkCalendario}
                                                                />
                                                            </div>
                                                            <div className="form-group col-lg-6">
                                                                <Label>Hasta: </Label>
                                                                <BlkField
                                                                    name="fcHasta"
                                                                    placeholder="Ingrese Fecha"
                                                                    component={BlkCalendario}
                                                                />
                                                            </div>
                                                        </Row>
                                                        <br />
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <div className="form-group col-lg-6">
                                                        <Button
                                                            type={"submit"}
                                                            color="primary"
                                                            className="mb-3 mr-2"
                                                            onClick={() => {
                                                                document
                                                                    .getElementById("siniestroGen")
                                                                    .scrollIntoView({ behavior: "smooth" });
                                                                submitForm();
                                                            }}
                                                        >
                                                            Buscar
                                                        </Button>
                                                        <Button
                                                            color="yellow"
                                                            className="mb-3 mr-2"
                                                            onClick={() => this.handleResetForm(resetForm)}
                                                        >
                                                            Nueva Consulta
                                                        </Button>
                                                    </div>
                                                </Row>
                                            </>
                                        )}
                                    </Form>
                                )}
                            </BlkFormik>
                            <div id={"siniestroGen"} />
                            <Label>Siniestros Generales: </Label>
                            <Row>
                                <Col xs={12}>
                                    <ReactTable
                                        noDataText={"No se ha encontrado información"}
                                        previousText={"Anterior"}
                                        nextText={"Siguiente"}
                                        pageText={"Página"}
                                        rowsText={"filas"}
                                        ofText={"de"}
                                        columns={[
                                            {
                                                Header: "No. Siniestro",
                                                id: "numSiniestro",
                                                sortable: false,
                                                minResizeWidth: 10,
                                                accessor: a => {
                                                    return a.numSiniestro + "-" + a.anoSiniestro;
                                                },
                                            },
                                            {
                                                Header: "Objeto",
                                                width: 150,
                                                sortable: false,
                                                accessor: "objeto.dscObjeto",
                                            },
                                            {
                                                id: "fcSiniestro",
                                                sortable: false,
                                                Header: "Fc Siniestro",
                                                minResizeWidth: 10,
                                                accessor: d => {
                                                    return moment(d.fcSiniestro)
                                                        .locale("moment/locale/es")
                                                        .local()
                                                        .format("DD/MM/YYYY");
                                                },
                                            },
                                            {
                                                Header: "Causa",
                                                minResizeWidth: 10,
                                                sortable: false,
                                                accessor: "causa",
                                            },
                                            {
                                                Header: "Estado",
                                                minResizeWidth: 10,
                                                sortable: false,
                                                accessor: "estadoActivo.estSiniestro.dscEstado",
                                            },
                                            {
                                                id: "objeto",
                                                Header: "Características",
                                                sortable: false,
                                                minResizeWidth: 10,
                                                accessor: ob => {
                                                    let veh = ob.objeto?.objCotizacion.vehiculo;
                                                    let msg = veh
                                                        ? `${veh.placa} ${veh.marca} ${veh.anioDeFabricacion} ${veh.color} ${veh.noDeMotor}
                                                                    ${veh.modelo} ${veh.noDeChasis}`
                                                        : null;

                                                    return <div title={msg}>{msg}</div>;
                                                },
                                            },
                                        ]}
                                        getTdProps={(state, rowInfo, column) => {
                                            if (rowInfo && rowInfo.row) {
                                                return {
                                                    onClick: (e, handleOriginal) => {
                                                        if (column.Header !== "Documentos") {
                                                            this.onSelectCoti(rowInfo.original);
                                                            this.setState({
                                                                selected: rowInfo.index,
                                                                item: rowInfo.original,
                                                            });
                                                        }
                                                        if (handleOriginal) {
                                                            handleOriginal();
                                                        }
                                                    },
                                                    style: {
                                                        cursor: "pointer",
                                                        //backgroundColor: rowInfo.index === this.state.selected ? '#47b2a2' : 'white',
                                                        color:
                                                            rowInfo.index === this.state.selected ? "white" : "black",
                                                        height: 35,
                                                    },
                                                    className:
                                                        rowInfo.index === this.state.selected ? "bg-primary" : "white",
                                                };
                                            } else {
                                                return {};
                                            }
                                        }}
                                        manual
                                        data={this.state.data}
                                        pages={this.state.pages}
                                        loading={this.state.loading}
                                        onFetchData={this.fetchData}
                                        defaultPageSize={10}
                                        className="-striped -highlight"
                                        page={this.state.page}
                                        pageSize={this.state.pageSize}
                                        onPageChange={page => this.setState({ page, selected: false })}
                                        onPageSizeChange={(pageSize, page) => this.setState({ page, pageSize })}
                                    ></ReactTable>
                                </Col>
                            </Row>
                            <br />
                            <br />
                        </div>
                    </CardBody>
                </Card>

                <DetallesGEN
                    open={this.state.modalSiniestroVidas}
                    toggleModal={this.showSiniestroVidas}
                    siniestro={this.state.item}
                    user={this.props.user}
                />
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    user: state.user,
    auth: state.auth,
});

const mapDispatchToProps = {
    on_select,
};
export default connect(mapStateToProps, mapDispatchToProps)(SiniestrosGEN);
